module.exports = __webpack_public_path__ + "img/zero-percent-icon.bdb36fec.png";